// Source : web/wp-content/themes/studiometa/src/js/utils/gsap.js
// Point d'entrée unique pour GSAP et ses plugins : garantit que
// `registerPlugin` n'est appelé qu'une seule fois, quel que soit le composant
// qui importe ce module.

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export { gsap, ScrollTrigger, SplitText };
